import { z } from 'zod';

/** Admin — 仅改二叉安置（挂点），不改推荐上级 */
export const AdminPlacementMoveSchema = z.object({
  /** 新安置父节点：用户名或玩家编号 */
  new_parent: z.string().min(1).max(32),
  position: z.enum(['L', 'R']),
  /**
   * true=整棵二叉子树随迁；false=先把直挂左右改挂到原父，再只迁本节点。
   * 必须显式传 0/1 或 boolean（挂回场景禁止默认 true）。
   */
  move_subtree: z.preprocess((val) => {
    if (val === true || val === 'true' || val === 1 || val === '1') return true;
    if (val === false || val === 'false' || val === 0 || val === '0') return false;
    return val;
  }, z.boolean({ required_error: '请选择是否带子树' })),
  /** 须与待迁用户名一致 */
  confirm_username: z.string().min(1).max(32),
  note: z.string().min(3).max(500),
  xian: z.boolean(),
});

export type AdminPlacementMoveRequest = z.infer<typeof AdminPlacementMoveSchema>;
